import { render, staticRenderFns } from "./DocTypesView.vue?vue&type=template&id=d22bc056&scoped=true"
import script from "./DocTypesView.vue?vue&type=script&lang=js"
export * from "./DocTypesView.vue?vue&type=script&lang=js"
import style0 from "./DocTypesView.vue?vue&type=style&index=0&id=d22bc056&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d22bc056",
  null
  
)

export default component.exports